import { motion } from "motion/react";
import type React from "react";
import { twJoin } from "tailwind-merge";

interface ProgressBarProps {
  // Progress percentage from 0 to 100
  progress: number;
  thickness?: "sm" | "md";
}

export function ProgressBar({ progress, thickness = "md" }: ProgressBarProps): React.ReactNode {
  const boundedProgress = Math.min(100, Math.max(0, progress));

  return (
    <span
      className={twJoin(
        "flex w-full overflow-hidden rounded-full bg-action-soft-primary-hover",
        thickness === "sm" && "h-progress-bar-sm",
        thickness === "md" && "h-progress-bar-md",
      )}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={boundedProgress}
    >
      <motion.span
        initial={{ x: "-100%" }}
        animate={{ x: `${boundedProgress - 100}%` }}
        transition={{ ease: "easeOut", duration: 0.3 }}
        className="size-full rounded-full bg-action-primary-hover"
      />
    </span>
  );
}
